import { Locale } from '@/models/system';
import { ProductType } from '@/models/product';

const translations = {
    email: {
        de: 'E-Mail',
        en: 'email',
    },
    title: {
        de: 'Titel',
        en: 'title',
    },
    firstname: {
        de: 'Vorname',
        en: 'firstname',
    },
    lastname: {
        de: 'Nachname',
        en: 'lastname',
    },
    salutation: {
        de: 'Anrede',
        en: 'salutation',
    },
    phone: {
        de: 'Telefon',
        en: 'telephone',
    },
    street: {
        de: 'Straße',
        en: 'street',
    },
    zipcode: {
        de: 'Postleitzahl',
        en: 'zipcode',
    },
    city: {
        de: 'Stadt',
        en: 'city',
    },
    country: {
        de: 'Land',
        en: 'country',
    },
    dragInFile: {
        de: 'Datei auswählen oder reinziehen',
        en: 'Click or drag in file',
    },
    mailTemplateFor: {
        de: 'Textvorlage für',
        en: 'Mail template for',
    },
    standardText: {
        de: 'Standardtext',
        en: 'Standard text',
    },
    new: {
        de: 'neu',
        en: 'new',
    },
    save: {
        de: 'speichern',
        en: 'save',
    },
    reset: {
        de: 'zurücksetzen',
        en: 'reset',
    },
    from: {
        de: 'von',
        en: 'from',
    },
    to: {
        de: 'bis',
        en: 'to',
    },
    marketingAcceptanceDate: {
        de: 'Marketing-Akzeptanzdatum',
        en: 'Marketing Acceptancedate',
    },
    mobileConfigurationTitle: {
        de: 'Webshop auf meiner mobilen Website',
        en: 'Webshop on my mobile website',
    },

    portalConfigurationTitle: {
        de: 'starjack.at & starjack App',
        en: 'starjack.at & starjack App',
    },
    integrationConfigurationTitle: {
        de: 'Webshop auf meiner Webseite',
        en: 'Webshop on my website',
    },

    b2bConfigurationTitle: {
        de: 'starjack.hospitality',
        en: 'starjack.hospitality',
    },
    keycard: {
        de: 'KeyCard',
        en: 'KeyCard',
    },
    barcode: {
        de: 'e-Ticket (Zutritt mit Barcode / QR Code Scanner) ',
        en: 'e-Ticket (Entrance with barcode / qr-code Scanner) ',
    },
    pickupOrder: {
        de: 'pick-up-Voucher (Abholung Automat oder Kassa)',
        en: 'pick-up-Voucher (Pikup at vending machine or cash desk)',
    },
    internalProductionOrder: {
        de: 'Produktion und Versand durch die Bergbahn',
        en: 'Production and shipping through liftoperator',
    },
    mobileFlow: {
        de: 'Handyticket',
        en: 'Mobile ticket',
    },
    selectNew: {
        de: 'Neu auswählen',
        en: 'Select new',
    },

    seasonTicket: {
        de: 'Saisonticket',
        en: 'Season Ticket',
    },

    dayTicket: {
        de: 'Tagesticket',
        en: 'Day Ticket',
    },
    language: {
        de: 'Sprache',
        en: 'Language',
    },
};

export type Translations = typeof translations;

export const getTranslated = (
    toBeTranslated: keyof Translations,
    locale: Locale = Locale.DE
) =>
    translations[toBeTranslated]
        ? translations[toBeTranslated][locale]
        : toBeTranslated;

export const getTicketTypeString = (productType: string, duration?: number) => {
    if (productType === ProductType.SEASON) {
        return getTranslated(
            `${productType.toLocaleLowerCase()}Ticket` as unknown as keyof Translations
        );
    } else {
        return `${duration} ${getTranslated(
            `${productType.toLocaleLowerCase()}Ticket` as unknown as keyof Translations
        )}`;
    }
};
